"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceUpdateTransport = exports.InvoiceCreateTransport = exports.CustomerInvoiceTransport = exports.InvoiceTransport = exports.ReviewStatus = exports.ReviewStatusLabels = exports.ReviewStatuses = exports.InvoiceStatus = exports.InvoiceStatusLabels = exports.InvoiceStatuses = exports.InvoiceType = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const sales_tax_1 = require("../pricing/sales-tax");
const line_item_transport_1 = require("./line-item-transport");
const payment_transport_1 = require("./payment-transport");
const refund_transport_1 = require("./refund-transport");
exports.InvoiceType = typebox_1.Type.Union([typebox_1.Type.Literal('payable'), typebox_1.Type.Literal('receivable')]);
exports.InvoiceStatuses = [
    'DRAFT',
    'PENDING',
    'PAID',
    'VOID',
    'PARTIALLY_PAID',
    'PARTIALLY_VOID',
    'PARTIALLY_REFUNDED',
    'REFUNDED',
    'PAST_DUE',
];
exports.InvoiceStatusLabels = {
    DRAFT: 'Draft',
    PENDING: 'Pending',
    PAID: 'Paid',
    VOID: 'Void',
    PARTIALLY_PAID: 'Partially Paid',
    PARTIALLY_VOID: 'Partially Void',
    PARTIALLY_REFUNDED: 'Partially Refunded',
    REFUNDED: 'Refunded',
    PAST_DUE: 'Past Due',
};
exports.InvoiceStatus = typebox_1.Type.Union(exports.InvoiceStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.ReviewStatuses = ['REVIEW_PENDING', 'REVIEW_APPROVED', 'REVIEW_REJECTED'];
exports.ReviewStatusLabels = {
    REVIEW_PENDING: 'Review Pending',
    REVIEW_APPROVED: 'Review Approved',
    REVIEW_REJECTED: 'Review Rejected',
};
exports.ReviewStatus = typebox_1.Type.Union(exports.ReviewStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.InvoiceTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    type: exports.InvoiceType,
    status: exports.InvoiceStatus,
    reviewStatus: typebox_1.Type.Optional(exports.ReviewStatus),
    void: typebox_1.Type.Boolean(),
    lineItems: typebox_1.Type.Array(line_item_transport_1.LineItemTransport),
    taxRate: typebox_1.Type.Number(),
    taxAmount: typebox_1.Type.Number(),
    taxAmountDollars: typebox_1.Type.Number(),
    total: typebox_1.Type.Number(),
    totalDollars: typebox_1.Type.Number(),
    payments: typebox_1.Type.Array(payment_transport_1.PaymentTransport),
    refunds: typebox_1.Type.Array(refund_transport_1.RefundTransport),
    remainingBalance: typebox_1.Type.Number(),
    remainingBalanceDollars: typebox_1.Type.Number(),
    paidInFull: typebox_1.Type.Boolean(),
    issueDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    term: typebox_1.Type.Integer({ minimum: 0 }),
    dueDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Boolean(),
    invoiceNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    isWaysteInvoice: typebox_1.Type.Boolean(),
    internalNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    memo: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 255 })),
    taxBreakdown: typebox_1.Type.Optional(sales_tax_1.TaxRateBreakDown),
    orderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    waysteOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    productInvoiceGroupingID: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceGroupingID: typebox_1.Type.Optional(typebox_1.Type.String()),
    commercialBillingActivityID: typebox_1.Type.Optional(typebox_1.Type.String()),
    commercialSubscriptionID: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderServiceLocation: typebox_1.Type.Optional(common_1.ServiceLocationTransport),
    waysteOrderNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Optional(common_1.MetaData),
});
exports.CustomerInvoiceTransport = typebox_1.Type.Omit(exports.InvoiceTransport, [
    'type',
    'syncedWithAccounting',
    'metadata',
    'totalDollars',
    'remainingBalanceDollars',
    'taxAmountDollars',
    'isWaysteInvoice',
]);
exports.InvoiceCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.InvoiceTransport, [
        'id',
        'type',
        'void',
        'lineItems',
        'taxAmount',
        'taxAmountDollars',
        'total',
        'totalDollars',
        'payments',
        'refunds',
        'remainingBalance',
        'remainingBalanceDollars',
        'paidInFull',
        'syncedWithAccounting',
        'isWaysteInvoice',
        'status',
        'reviewStatus',
    ]),
    typebox_1.Type.Object({
        void: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        lineItems: typebox_1.Type.Array(line_item_transport_1.LineItemInputTransport),
        taxAmount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        taxAmountDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
        syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.InvoiceUpdateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.InvoiceTransport, [
        'id',
        'type',
        'lineItems',
        'total',
        'totalDollars',
        'payments',
        'refunds',
        'remainingBalance',
        'remainingBalanceDollars',
        'paidInFull',
        'isWaysteInvoice',
        'status',
        'orderNumber',
        'orderServiceLocation',
        'memo',
        'internalNotes',
        'reviewStatus',
    ])),
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Optional(typebox_1.Type.Array(line_item_transport_1.LineItemInputTransport)),
        memo: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ maxLength: 255 }))),
        internalNotes: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    }),
]);
//# sourceMappingURL=invoice-transport.js.map